import React, { useState, useEffect } from 'react';
import { useToast } from '../../contexts/ToastContext';
import { administratorService } from '../../services/userService';
import { Administrator } from '../../types/User';
import './UserForm.css';

interface AdministratorFormProps {
  administrator: Administrator | null;
  onSuccess: () => void;
  onCancel: () => void;
}

const AdministratorForm: React.FC<AdministratorFormProps> = ({ administrator, onSuccess, onCancel }) => {
  const { showToast } = useToast();
  const [formData, setFormData] = useState<Administrator>({
    nombre: '',
    nif: '',
    email: '',
    telefono: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (administrator) {
      setFormData(administrator);
    }
  }, [administrator]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (administrator?.id) {
        await administratorService.update(administrator.id, formData);
        showToast('Administrador actualizado correctamente');
      } else {
        await administratorService.create(formData);
        showToast('Administrador creado correctamente');
      }
      onSuccess();
    } catch (err: any) {
      setError(err.response?.data?.message || 'Error al guardar el administrador');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="user-form">
      <h3>{administrator ? 'Editar Administrador' : 'Crear Administrador'}</h3>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group span-2">
            <label htmlFor="nombre">Nombre *</label>
            <input
              type="text"
              id="nombre"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
              maxLength={100}
            />
          </div>
          <div className="form-group">
            <label htmlFor="nif">NIF *</label>
            <input
              type="text"
              id="nif"
              name="nif"
              value={formData.nif}
              onChange={handleChange}
              required
              maxLength={20}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group span-2">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              maxLength={100}
            />
          </div>
          <div className="form-group">
            <label htmlFor="telefono">Teléfono</label>
            <input
              type="tel"
              id="telefono"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              maxLength={20}
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="button" onClick={onCancel} className="btn-secondary" disabled={loading}>
            Cancelar
          </button>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Guardando...' : administrator ? 'Actualizar' : 'Crear'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdministratorForm;
